<template>
   <div v-if="loading" class="spinner-container">
      <div class="spinner"></div>
    </div>
    <div v-else>
          <!-- Keep-alive should wrap <router-view /> -->
         
    <div class="homepage d-flex flex-column vh-100">
         <!-- navbar -->
         <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary">
            <div class="d-flex align-items-center">
         
               <span @click="goBack()" class="text-white"><i class="bi bi-arrow-left fs-5"></i></span> &nbsp; &nbsp;
                  
                  <span>
                     <h4 class="text-white">{{language?.menu_user}}</h4>
                  </span>
         
            
               <div class="d-flex align-items-center gap-2 ms-auto">
                
                 <a href="#" class="link-dark text-truncate d-flex align-items-center gap-2" data-bs-toggle="offcanvas" data-bs-target="#branch"
                  aria-controls="branch">
                  <b class="bg-dark bg-opacity-75 rounded-circle user-icon">
                  <i class="bi bi-plus  d-flex m-1 h4 text-white"></i>
                  </b>
                  </a>
               </div>
            </div>
            



         </div>
    
         <!-- body -->
         <div class="my-auto overflow-auto vh-100">
           
            <!-- Top Evets -->
            <div class="pt-3 bg_card">
               
               <div class="row">
                  <!-- 1st item -->
                  <div class="">
                    
                     <div class="card  border-1 overflow-hidden " v-for="(user,i) in users">
                        
                                 <div class="card-body">
                                   <b>{{user.name}}</b>
                                   <div>{{user.laundry_name}}</div>
                                   <div v-if="user.branch_name">{{user.branch_name}}</div>
                                   <div>{{user.mobile}}</div>
                                   <div>{{user.role}}</div>
                                </div>
                            
                        <div
                           class="card-footer ">
                           <div>
                              <span class="badge bg-success" @click="editUser(user)"><i class="bi bi-pen"></i> &nbsp;{{language?.edit}}</span> &nbsp; &nbsp; 
                              <span class="badge bg-danger" v-if="users.length>1" @click="deleteUser(user.id)"><i class="bi bi-trash"></i> &nbsp;{{language?.delete}}</span>&nbsp; &nbsp; 
                              <span class="badge btn-primary" @click="addvoucher(user.id)">
                                 <i class="bi bi-plus"></i> &nbsp; {{language?.add_voucher}}
                               </span>
                           </div>
                            
                        </div>

                     </div> 
                  </div> 
                  
               </div> 
            </div>

       


 


  
         </div>
         
         <div class="offcanvas offcanvas-end border-0" tabindex="-1" id="branch" aria-labelledby="branchLabel">
         <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
            <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i class="bi bi-arrow-left fs-5 text-white"></i></a>
            <h6 class="offcanvas-title text-white m-0" id="branchLabel">{{language?.create_new_user}}</h6>
         </div>
         <div class="offcanvas-body">
           
                 
                    

                    <div class="mb-3">
                     <label for="name" class="form-label">{{language?.user_name}}</label>
                     <input type="text" id="name" v-model="user.name" class="form-control" required>
                 </div>

                 <div class="mb-3">
                  <label for="mobile" class="form-label">{{language?.user_contact}}</label>
                  <input type="number" id="mobile" v-model="user.mobile" class="form-control" required>
                 </div>

                 <div class="mb-3">
                    <label for="password" class="form-label">{{language?.user_password}}</label>
                    <input type="password" id="password" v-model="user.password" class="form-control" required>
                   </div>

         

                   <div class="mb-3">
                    <label for="role" class="form-label">{{language?.user_role}}</label>
                    <select id="role" v-model="user.role" class="form-control" required>
                        <option value="" disabled>{{language?.select_role}}</option>
                        <option value="Admin">{{language?.admin}}</option>
                        <option value="Worker">{{language?.worker}}</option>
                        </select>
                    </div>
                
                    
                   <div class="mb-3">
                    <label for="branch" class="form-label">{{language?.select_branch}}</label>
                    <select id="laundry" v-model="user.branchid" class="form-control" required>
                        <option value="" disabled>{{language?.select_branch}}</option>
                        <option v-for="branch in branchlist" :key="branch.id" :value="branch.id">
                            {{ branch.name }}
                        </option>
                    </select>
                   </div>


                  <div class="d-flex gap-2">
                    <button class="btn btn-primary w-100 " @click="addUser">{{language?.save}}</button>
                    <button class="btn btn-secondary w-50" @click="goprevious">{{language?.back}}</button>
                  </div>
                 
         </div>
      </div>


<!-- voucher canvas -->
      <div class="offcanvas offcanvas-end border-0" tabindex="-1" id="showvoucher" aria-labelledby="voucherLabel">
         <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
            <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i class="bi bi-arrow-left fs-5 text-white"></i></a>
            <h6 class="offcanvas-title text-white m-0" id="voucherLabel">{{language?.add_voucher}}</h6>
         </div>
         <div class="offcanvas-body">
           
                
                    <div class="mb-3">
                        <label for="date" class="form-label">{{language?.date}}</label>
                        <input type="date" id="date" v-model="voucher.voucher_date" class="form-control" required>
                    </div>

                    <div class="mb-3">
                     <label for="amount" class="form-label">{{language?.amount}}</label>
                     <input type="number" id="amount" v-model="voucher.amount" class="form-control" required>
                 </div>

                 <div class="mb-3">
                     <label for="remark" class="form-label">{{language?.remark}}</label>
                     <textarea id="remark" v-model="voucher.remark" class="form-control" rows="2" required></textarea>
                 </div>
                 
                    
                  <div class="d-flex gap-2">
                     <button class="btn btn-primary w-100 " @click="savevoucher">Save</button>
                    
                  </div>
                 
         </div>
      </div>



      </div>
    </div>
</template>
  
<script> 
import axios from "@/plugins/axios";  

export default {
  name: 'Branch',
  components: { 
  },
  mounted() { 
   //  this.fetchWeather();
    this.getBranches(); // Call the method here
    
},
  data() {
    return { 
      loading:false,
      error:null,
      isUserLogged:false,
      user_details:[],
      laundrylist:[],
      branchlist:[],
      users:[],
      language:this.getLocalStorageArray('lang'),
      user:{
         laundryid:'',
         name:'',
         mobile:'',
         password:'',
         role:'',
         branchid:'',
      },

      voucher:{
        voucher_date:new Date().toISOString().split('T')[0],
        amount:'',
        remark:'',
        userid:0

      },

      branches:[], 
      branch_name:''

    }
  },
  methods:{
    initializeHomeContent(){
    

    },


    addvoucher(userid) {
        
        window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("showvoucher")).show();
         this.voucher.userid=userid;
         
     }, 

    goBack() {
          
          this.$router.go(-1);
  },
  goprevious() {
          
          this.$router.go("/branch");
  },

 

 
    async getBranches() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("getalluser").then((response) => {
               self.branches=response.data.branches;
               self.laundrylist=response.data.laundrylist;
               self.branchlist=response.data.branchlist;
               self.users=response.data.users;
               self.language=response.data.language;
               localStorage.setItem('lang',response.data.language);
             
          }).then(() => {
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 





       addUser() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("addUser",self.user).then((response) => {
              
                     self.branches=response.data.branches;
                     self.users=response.data.users;
                     self.$swal.fire(response.data.message);
                     if(response.data.success)
                     {
                        self.branch={ name:'',         address:'',contact:'',};
                     }
                     window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).hide();
                      

               
        
          }).then(() => {
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 


      editUser(editUser) {
         window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).show();
         this.user=editUser;
      }, 





    deleteUser(id = "") {
    this.loading = true;
    this.error = null;

    try {
        var self = this;

        this.$swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel",
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post("deleteUser", { id: id }).then((response) => {
                    self.branches = response.data.branches;
                    self.users=response.data.users;
                    self.$swal.fire(response.data.message);
                    if (response.data.success) {
                        window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).hide();
                    }
                }).then(() => {
                    
                    
                    self.initializeHomeContent();
                }).catch((err) => {
                    self.$swal.fire("Error!", "Something went wrong.", "error");
                });
            }
        });

    } catch (err) {
        this.error = err.response?.data?.message || "Login failed. Please try again.";
    } finally {
        this.loading = false;
    }
},


savevoucher() {
    this.loading = true;
    this.error = null;

    try {
        var self = this;
        if (self.voucher.userid < 0) {
            self.$swal.fire("Empty Customer");
        } else if (self.voucher.amount == '') {
            self.$swal.fire("Amount is empty");
        } else {
            axios.post("saveuuservoucherdata", self.voucher).then((response) => {
                
            // self.customerlist = response.data.customerlist;
            // self.filteredcustomerList = self.customerlist; 

                self.$swal.fire(response.data.message);
                if (response.data.success) {
                    self.voucher = { voucher_date: '', amount: '', remark: '', custid: 0 };
                }
                
                window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("showvoucher")).hide();
            }).then(() => {
                self.initializeHomeContent();
            });
        }
    } catch (error) {
        console.error(error);
        self.$swal.fire("An error occurred while saving the voucher.");
    } finally {
        this.loading = false;
    }
},



getLocalStorageArray(key) {
        let data = localStorage?.getItem(key);
        try {
            return data ? JSON.parse(data) : [];
        } catch (e) {
            console.error("Error parsing localStorage data", e);
            return [];
        }
    }














  }
}






</script>
